import "./assets/scss/style.scss"
import "./lib/utils/stringUtils"

import React from "react"
import ReactDOM from 'react-dom/client'
import { Provider } from "react-redux"
import { RouterProvider, createBrowserRouter } from "react-router-dom"


import Store from "./Store"
import { getAppRoutes } from "./routes/Router"

const router = createBrowserRouter( getAppRoutes(), {
    future: {
      v7_startTransition: true,
    }
  }
)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={Store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
)
